/*
 * Static layout-level JS extracted from layout/theme.liquid inline <script>s
 * (perf: shrink the HTML document so the LCP image / stylesheets are discovered
 * sooner). Contains NO Liquid — safe to cache. Loaded with `defer`.
 *
 * 1) Header-height measurement → sets --header-* CSS custom properties.
 * 2) `?discount=` URL param → applies the discount via Shopify's /discount route.
 */
(function () {
  'use strict';

  // ---- Header height measurement ------------------------------------------
  function throttle(func, delay) {
    let timeoutId;
    let lastExecTime = 0;
    return function (...args) {
      const currentTime = Date.now();

      if (currentTime - lastExecTime > delay) {
        func.apply(this, args);
        lastExecTime = currentTime;
      } else {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          func.apply(this, args);
          lastExecTime = Date.now();
        }, delay - (currentTime - lastExecTime));
      }
    };
  }

  function calculateHeaderHeight() {
    // Sensible defaults so layout doesn't jump before measurement.
    document.body.style.setProperty('--header-height-with-algolia-bar', '182px');
    document.body.style.setProperty('--header-top-bar-height', '68px');

    const bar = document.querySelector('.header__bar');
    const headerTopBar = bar ? bar.getBoundingClientRect().height : 68;

    if (window.innerWidth < 1024) {
      document.body.style.setProperty('--header-height', '100px');
      document.body.style.setProperty('--header-top-bar-height', `${headerTopBar}px`);
    } else {
      document.body.style.setProperty('--header-height', '115px');
      document.body.style.setProperty('--header-top-bar-height', `${headerTopBar}px`);
    }

    const headerGroup = document.querySelector('sticky-header.header');
    if (!headerGroup) return;

    const headerHeight = headerGroup.getBoundingClientRect().height;
    document.body.style.setProperty('--header-height', `${headerHeight}px`);

    const searchHeader = document.querySelector('.search-header');
    if (searchHeader) {
      document.body.style.setProperty(
        '--header-height-with-algolia-bar',
        `${headerHeight + searchHeader.getBoundingClientRect().height}px`
      );
    }
  }

  // Expose globally (kept from the original inline version in case other
  // scripts referenced window.calculateHeaderHeight / window.throttle).
  window.calculateHeaderHeight = calculateHeaderHeight;
  window.throttle = window.throttle || throttle;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', calculateHeaderHeight);
  } else {
    calculateHeaderHeight();
  }
  window.addEventListener('resize', throttle(calculateHeaderHeight, 250));

  // ---- ?discount= redirect -------------------------------------------------
  try {
    const params = new URLSearchParams(window.location.search);
    const discount = params.get('discount');
    if (discount) {
      fetch('/discount/' + encodeURIComponent(discount), {
        method: 'GET',
        redirect: 'follow',
      });
    }
  } catch (e) {
    /* no-op: never let this break the page */
  }
})();
